module.exports = __webpack_public_path__ + "img/Sales Color.972893cb.svg";